import { theme } from '@citygross/design-tokens';
import { EPriceSize, EPriceVariant } from '../components/PriceTag/PriceTag.types.js';

var getPriceStripeSizeAttributes = function getPriceStripeSizeAttributes(size) {
  switch (size) {
    case EPriceSize.LARGE:
      return {
        fontSize: 14
      };

    case EPriceSize.MEDIUM:
      return {
        fontSize: 13
      };

    case EPriceSize.SMALL:
      return {
        fontSize: 10
      };

    default:
      return {};
  }
};

var getPriceTagSizeAttributes = function getPriceTagSizeAttributes(size) {
  switch (size) {
    case EPriceSize.LARGE:
      return {
        baseFontSize: 46,
        decimalsFontSize: 25,
        detailsNoPantWidth: 30,
        detailsPantWidth: 36,
        indicatorSize: 25,
        unitFontSize: 12
      };

    case EPriceSize.MEDIUM:
      return {
        baseFontSize: 38,
        decimalsFontSize: 20,
        detailsNoPantWidth: 25,
        detailsPantWidth: 30,
        indicatorSize: 20,
        unitFontSize: 11
      };

    case EPriceSize.SMALL:
      return {
        baseFontSize: 28,
        decimalsFontSize: 15,
        detailsNoPantWidth: 20,
        detailsPantWidth: 22,
        indicatorSize: 15,
        unitFontSize: 8
      };

    default:
      return {};
  }
};

var getPriceVariantAttributes = function getPriceVariantAttributes(priceVariant) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

  switch (priceVariant) {
    case EPriceVariant.CAMPAIGN:
      return {
        backgroundColor: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.brandYellow,
        fontColor: (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.priceTagRed
      };

    case EPriceVariant.KLIPP:
      return {
        backgroundColor: (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.alertRed,
        fontColor: (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.white
      };

    case EPriceVariant.PRIO:
      return {
        backgroundColor: (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.brandPrio,
        fontColor: (_f = theme.palette) === null || _f === void 0 ? void 0 : _f.white
      };

    case EPriceVariant.REGULAR:
      return {
        backgroundColor: (_g = theme.palette) === null || _g === void 0 ? void 0 : _g.white,
        fontColor: (_h = theme.palette) === null || _h === void 0 ? void 0 : _h.darkest
      };

    default:
      return {
        backgroundColor: (_j = theme.palette) === null || _j === void 0 ? void 0 : _j.white,
        fontColor: (_k = theme.palette) === null || _k === void 0 ? void 0 : _k.darkest
      };
  }
};

var getPriceStripeAttributes = function getPriceStripeAttributes(priceSize, priceVariant) {
  return {
    sizeAttributes: getPriceStripeSizeAttributes(priceSize),
    variantAttributes: getPriceVariantAttributes(priceVariant)
  };
};

var getPriceTagAttributes = function getPriceTagAttributes(priceSize, priceVariant) {
  return {
    sizeAttributes: getPriceTagSizeAttributes(priceSize),
    variantAttributes: getPriceVariantAttributes(priceVariant)
  };
};

export { getPriceStripeAttributes, getPriceTagAttributes };